import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import isYesterday from 'date-fns/is_yesterday';

const fallbacks = {
  en: 'en-US',
  'es-LA': 'en-US',
  es: 'en-US',
  fi: 'en-US',
  fr: 'en-US',
  de: 'en-US',
  pl: 'en-US',
  it: 'en-US',
  ja: 'en-US',
  ko: 'en-US',
  ru: 'en-US',
  sk: 'en-US',
  cs: 'en-US',
  da: 'en-US',
  sl: 'en-US',
  sv: 'en-US',
  zh: 'zh-CHS',
  'zh-CN': 'zh-CHS',
  'zh-TW': 'zh-TW',
  'zh-HK': 'zh-TW',
  'zh-SG': 'zh-CHS',
  'zh-MY': 'zh-CHS',
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .init({
    load: 'currentOnly',
    cleanCode: true,
    fallbackLng: __REGION__.defaultLanguage,
    debug: __DEV__ && true,
    interpolation: {
      escapeValue: false, // not needed for react!!
      format: (value, formatType) => {
        if (formatType === 'TimeFromNow') {
          if (isToday(value)) {
            return format(value, '[Today] [at] HH:mm');
          } if (isYesterday(value)) {
            return format(value, '[Yesterday] [at] HH:mm');
          }
          return format(value, 'DD.MM.YYYY [at] HH:mm');
        }
        if (value instanceof Date) return format(value);
        return value;
      },
    },
    backend: {
      loadPath(lngs) {
        const mapped = [
          ...lngs.map((lng) => fallbacks[lng]),
          ...lngs.map((lng) => fallbacks[lng.split('-')[0]]),
          __REGION__.defaultLanguage,
        ];
        return mapped.filter((l) => l !== undefined)[0];
      },
      request: (options, url, payload, callback) => {
        try {
          const data = require(`./locales/${url}.json`); // eslint-disable-line global-require,import/no-dynamic-require
          callback(null, { status: '200', data });
        } catch (e) {
          callback(e, null);
        }
      },
    },

    // react i18next special options (optional)
    react: {
      wait: true, // set to true if you like to wait for loaded in every translated hoc
      nsMode: 'default', // set it to fallback to let passed namespaces to translated hoc act as fallbacks
    },
  });

export default i18n;
